import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Currencies } from 'src/app/models/Configurations/Currencies';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';
import { SessionService } from 'src/app/services/session/session.service';

@Component({
  selector: 'currency-option-box',
  templateUrl: './currency-option-box.component.html',
  styleUrls: ['./currency-option-box.component.scss']
})
export class CurrencyOptionBoxComponent implements OnInit {

  @Output() currencyChanged = new EventEmitter<Currencies>();

  get currencies(): Currencies[] {
    return this.configService.currencies;
  }

  get currentCurrencyCompany(): Currencies | null {
    return this.currencies.find(x => x.code == this.sessionService.getDetails().currency) ?? null;
  }

  constructor(private configService: ConfigurationService,
    private sessionService: SessionService) {
  }

  ngOnInit(): void {
  }

  currencySelected(value: Currencies) {
    if (Object.keys(value).length) {
      this.currencyChanged.emit(value);
    }
  }

}
